import React from 'react';
import ReactDOM from 'react-dom';
import ExecutiveItem from './executive-item.jsx';
import { populate } from './../utils/populate.js';

class Executives extends React.Component{
  constructor(props) {
    super(props);
    this.state = {
      baseQuery: "/rest/board-members?_format=json",
      query: "&membership_type=Non-Executive Member",
      data: [],
    };

    this.populateAll = this.populateAll.bind(this);

  }

  componentDidMount() {
    this.populateAll();
  }

  populateAll() {
    const { baseQuery, query } = this.state;
    const that = this;
    populate(`${baseQuery}${query}`).then(function( response ){
      that.setState({
        data: response
      })
    });
  }

  render() {
    const { data} = this.state;

      return(
        <div className="board--members--non--exectutive">
          <h2 className="heading heading__large">Non-Executive Members</h2>
          {
            data.map((item, index) => {
              return(
                <ExecutiveItem item={item} key={index} />
              );
            })
          }
        </div>
      )
  }
}

if ( document.getElementById('react--board--members-----non--executive') ) {
  ReactDOM.render(
    <Executives/>,
    document.getElementById('react--board--members-----non--executive')
  );

}









